import React, { FC } from 'react';

import { VbzButton } from '@smiles/voebiz-ui-kit';
import { ModalBody } from 'reactstrap';

interface SuccessProps {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  onClick: any;
  tier?: string;
}

const ModalMaintenanceBody: FC<SuccessProps> = ({ onClick, tier }) => (
  <ModalBody>
    <div className="smls-modal-header">
      <h4>Sua categoria foi renovada!</h4>
    </div>

    <p>
      Sua empresa juntou o valor de passagens aéreas necessário para se manter na categoria {tier}.
      <br />
      <br />
      Continue aproveitando todos os benefícios.
    </p>

    {/* <SmlsButton */}
    <VbzButton id="submit" className="vbz-update-modal-btn" text="Acessar benefícios" onClick={onClick} />
  </ModalBody>
);

ModalMaintenanceBody.defaultProps = {
  tier: undefined,
};

export default ModalMaintenanceBody;
